export default {
    methods: {
        onKeyEvent(e) {
            if (!this.opened)
                return;

            switch (e.code) {
                case 'Escape':
                case 'Tab':
                    this.opened = false;
                    return;
            }
        },
        onMouseEvent(e) {
            if (this.opened && !this.$el.contains(e.target)) {
                this.opened = false;
            }
        },
    },
    mounted() {
        document.addEventListener('keydown', this.onKeyEvent, true);
        document.addEventListener('click', this.onMouseEvent, true);
    },
    destroyed() {
        document.removeEventListener('keydown', this.onKeyEvent, true);
        document.removeEventListener('click', this.onMouseEvent, true);
    },
};
